<template>
  <div>
    <generic-container
      :title="$t('course record seasons')"
      icon="certificate"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      :header_buttons="header_buttons"
    >
      <div class="ui three cards">
        <season
          :season="season"
          v-for="(season, index) in seasons"
          :key="index"
          @phase_confirmed="refresh"
          @emit_show_record="emit_show_record"
          @emit_show_reprint="emit_show_reprint"
        />
      </div>
    </generic-container>
    <record-modal ref="record_modal" @record_generated="refresh" />
    <reprint-record-modal ref="reprint_record_modal" />
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import { local_api, error_toast } from "@/utils";
import Season from "./Season.vue";
import RecordModal from "./record_modal/Index.vue";
import ReprintRecordModal from "./reprint_record_modal/ReprintIndex.vue";

// @ is an alias to /src
export default {
  name: "CourseRecordIndex",
  components: {
    "generic-container": GenericContainer,
    Season,
    RecordModal,
    ReprintRecordModal,
  },
  filters: filters,
  data() {
    return {
      seasons: [],
      configure_modal: ConfigureModal,
      selected_assignation: undefined,
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
      ],
    };
  },
  methods: {
    refresh() {
      let vm = this;
      local_api(vm, "post", "/course/record/do-get-season-list", {})
        .then((seasons) => {
          vm.seasons = seasons;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    emit_show_record(section) {
      this.$refs.record_modal.show_modal(section);
    },
    emit_show_reprint(record) {
      this.$refs.reprint_record_modal.show_modal(record);
    },
  },
  created() {},
  mounted() {
    this.refresh();
  },
  watch: {},
};
</script>
